import React from "react";
import { Stack, Typography } from "@mui/material";
import { style } from "./style";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { InfoCardTable } from ".";

export const OtherTargetInfoCard = ({
  title,
  data = [],
  Icon = AccountTreeIcon,
}) => {
  const tableData = {
    head: [
      {
        label: "Impact Target",
        name: "title",
      },
      {
        label: "Monthly Impact",
        name: "perMonth",
      },
      {
        label: "Yearly Impact",
        name: "total",
      },
    ],
    rowData: data.otherTargets.map((exp) => {
      return {
        title: exp.grantQuestion.question,
        perMonth: exp.perMonth,
        total: exp.total,
      };
    }),
  };
  return (
    <>
      <Stack sx={style.infoCardBackground}>
        {/* Header */}
        <Stack
          sx={{ ...style.infoCardHead, p: 0, justifyContent: "space-between" }}
        >
          <Stack direction={"row"} alignItems={"center"} gap={1} p={2}>
            <Stack sx={style.infoCardHeadIcon}>
              <Icon />
            </Stack>
            <Typography variant="h3" sx={{ fontWeight: 500 }}>
              {title}
            </Typography>
          </Stack>
        </Stack>
        {/* Content */}
        <InfoCardTable tableData={tableData} />
      </Stack>
    </>
  );
};
